<template>
<div class="exp-array panel panel-expADI">
  <div class="panel-heading">
    <div class="panel-title">
      <div class="row">
        <div class="col-xs-12 col-sm-6">
          <h4>
            <strong>
              Service «{{uf}}» ({{ code }})
            </strong>
          </h4>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-4 col-md-offset-2">
          <span class="pull-right">
            <select v-model.trim="exp.selection"
                    class="form-control">
              <option v-for="(r, i) in exp.arrays"
                      :key="`exp-array-${i}`"
                      :value="r">{{ r.name }}
              </option>
            </select>
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="panel-body">
    <btn v-if="debug" type="danger" @click="dbgFill">
      <span class="glyphicon glyphicon-wrench" aria-hidden="true"></span>
      Remplir
    </btn>

    <div v-if="exp.selection" class="exp-array-tables">
      <div v-for="(t, k) in exp.selection.tables"
           :key="`table-${exp.selection.key}-${k}`">
        <denom-table header
                     v-model="model[k]"
                     :columns="t.columns"
                     :code="code"
                     :module="module"
                     @progress="progress(k, $event)">
        </denom-table>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import rand from '@/sui/tools/rand'
import sc from '@/sui/components/sc/expArray'
import denomTable from '@/sui/components/denomTable'

export default {
  name: 'exp-array',

  props: {
    uf: {
      required: true,
      type: String
    },

    year: {
      required: true,
      type: Number
    },

    code: {
      required: true,
      type: String
    },

    value: {
      required: true,
      type: Object
    },

    module: {
      type: String,
      required: true
    }
  },

  data: function () {
    const version = this.year >= 2025 ? this.year : 'base'
    return {
      model: null,
      exp: {
        selection: null,
        arrays: sc.arrays[version]
      }
    }
  },

  watch: {
    model: {
      handler: function (v) {
        const result = {}
        for (let i in v) {
          const l = v[i]
          for (let k in l) {
            result[k] = l[k]
          }
        }

        this.$emit('input', result)
      },
      deep: true
    },

    value: {
      handler: function (t) {
        // this.model = this.value
      },
      deep: true
    },

    'exp.selection.tables': function (n, o) {
      if (o == null) {
        return
      }

      for (let k = o.length; k > n.length; --k) {
        const nc = {
          key: `${this.code}-${this.uf}-${k - 1}-exp`
        }
        this.$emit('progress', nc)
      }
    },

    'exp.selection': function (n, o) {
      this.$emit(
        'array',
        {
          new: sc.getDenominators(n),
          old: sc.getDenominators(o)
        }
      )
      const model = []
      for (let i in this.exp.selection.tables) {
        const t = this.exp.selection.tables[i]
        const value = {}
        for (let j in t.columns) {
          const c = t.columns[j]
          if (c.title !== '') {
            value[c.key] = this.value[c.key]
          }
        }
        model.push(value)
      }
      this.model = model
    }
  },

  mounted: function () {
    const t = this.value
    for (let j in this.exp.arrays) {
      const a = this.exp.arrays[j]
      const d = sc.getDenominators(a)
      let i = 0
      while (i < d.length && t[d[i]] != null) {
        ++i
      }
      if (i === d.length) {
        this.exp.selection = a
        return
      }
    }

    this.exp.selection = this.exp.arrays[0]
  },

  components: {
    'denom-table': denomTable
  },

  computed: {
    debug: function () {
      return process.env.VUE_APP_SPIADI_DEBUG === '1'
    }
  },

  methods: {
    progress: function (k, counts) {
      const nc = {
        total: counts.total,
        alert: counts.alert,
        missing: counts.missing,
        key: `${this.code}-${this.uf}-${k}-exp`
      }
      this.$emit('progress', nc)
    },

    dbgFill: function () {
      const vm = this
      this.$nextTick(
        () => {
          const model = []
          for (let i in vm.exp.selection.tables) {
            const t = vm.exp.selection.tables[i]
            const value = {}
            for (let j in t.columns) {
              const c = t.columns[j]
              if (c.title !== '') {
                value[c.key] = `${rand.getInt(30, 100)}`
              }
            }
            model.push(value)
          }
          vm.model = model
        }
      )
    }
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.exp-array {
  .exp-array-tables {
    margin-top: 1rem;
  }

  table {
    table-layout: fixed;
    margin-bottom: 0px;
  }

  th, td {
    text-align: center;
  }

  select {
    margin-top: 0.3rem;
  }
}
</style>
